import React, { Component } from 'react';
import { connect } from 'react-redux';
import Player from './Player'
import Ball from './Ball'
import Linesman from './Linesman'
import Referee from './Referee'
import Manager from './Manager'
import Gate from './Gate'
import * as UserActions from '../../actions/UserActions';
import { bindActionCreators } from 'redux';
import $ from "jquery";
import * as GameActions from '../../actions/gameActions'
import Goal from '../Animations/Scenes/Goal'
import OwnGoal from '../Animations/Scenes/OwnGoal'
import Substitution from '../Animations/Scenes/Substitution'
import YellowCard from '../Animations/Scenes/YellowCard'
import RedCard from '../Animations/Scenes/RedCard'
import Offside from '../Animations/Scenes/Offside'
import EndGame from '../Animations/Scenes/EndGame'
import HalfTime from '../Animations/Scenes/HalfTime'
import { getInterval } from './gameJson'
import * as sceneTypes from '../Animations/Scenes/SceneTypes'

class Pitch extends Component {

    static propTypes = {
        width: React.PropTypes.number.isRequired,
        height: React.PropTypes.number.isRequired,
        ident: React.PropTypes.number.isRequired,
        weather: React.PropTypes.number.isRequired,
        halfTime: React.PropTypes.number = 0,
        windowMode: React.PropTypes.bool.isRequired
    }

    constructor(props) {
        super(props);
        this.weather = this.props.weather;
        this.PitchIdent = 0;
        this.ServerPitchWidth = 720;
        this.ServerPitchHeight = 450;
        this.ServerPenaltyBoxWidth = 100;
        this.ServerPenaltyBoxHeight = this.ServerPenaltyBoxWidth * 40 / 16.5;

        this.PitchImageWidth = 0;
        this.PitchImageHeight = 0;

        this.PitchPenaltyBoxWidth = 0;
        this.PitchPenaltyBoxHeight = 0;

        this.PitchGateHeight = this.PitchPenaltyBoxHeight  * 7.32 / 40;
        this.PitchGateWidth = this.PitchGateHeight *0.35;

        this.metr = this.PitchPenaltyBoxHeight  * 1 / 40;
        this.server_metr = this.ServerPenaltyBoxWidth / 16.5;
        this.technicalZoneWidth = 16 * this.metr;
        this.technicalZoneHeight = 5 * this.metr;
        this.distanceBeetwenZones = 2 * this.metr;

        this.LeftGateTop = 0;
        this.LeftGateLeft = 0;
        this.RightGateLeft = 0;
        this.RightGateTop = 0;

        this.players = [];
        this.ball = null;
        this.cancelSceneToken = null;

        this.Settings = window.PitchSettings;
        this.halfTime = 0;

    }

    calculateHtmlPositions(){
      var pitch = $('#'+this.getCanvasPitchId());
      var height = pitch.height();

      var outerHeight = pitch.outerHeight();
      var offset = pitch.offset();

      this.PitchIdent = this.props.ident;

      this.PitchImageWidth = pitch.width() - this.PitchIdent * 2;
      this.PitchImageHeight = pitch.height() - this.PitchIdent * 2;

      this.PitchPenaltyBoxWidth = this.ServerPenaltyBoxWidth * this.PitchImageWidth / this.ServerPitchWidth;
      this.PitchPenaltyBoxHeight = this.ServerPenaltyBoxHeight * this.PitchImageHeight / this.ServerPitchHeight;

      this.PitchGateHeight = this.PitchPenaltyBoxHeight  * 7.32 / 40;
      this.PitchGateWidth = this.PitchGateHeight *0.35;

      this.metr = this.PitchPenaltyBoxHeight  * 1 / 40;
      this.server_metr = this.ServerPenaltyBoxWidth / 16.5;
      this.technicalZoneWidth = 21 * this.metr;
      this.technicalZoneHeight = 5 * this.metr;
      this.distanceBeetwenZones = 2 * this.metr;

      var p = document.getElementById(this.getPitchContainerId());
      var style = /*p.currentStyle ||*/ window.getComputedStyle(p);
      
      this.OffsetTop = parseInt(style.marginTop) + (this.props.windowMode ? 32 : 0)///offset.top;
      this.OffsetLeft = parseInt(style.marginLeft) + (this.props.windowMode ? 5 : 16)//bootstrap .container margin-left;
      
      if(navigator.userAgent.toLowerCase().indexOf('firefox') > -1 && !this.props.windowMode) {
        this.OffsetLeft = (($('body').outerWidth( true ) - $("#new_pitch").outerWidth( true )) - ($('body').outerWidth( true ) - $("#field-col").outerWidth( true ))) / 2 
      }

      this.LeftGateTop = this.PitchIdent + this.OffsetTop - 1 + this.PitchImageHeight/2 - this.PitchGateHeight/2;
      this.LeftGateLeft = this.PitchIdent + this.OffsetLeft - this.PitchGateWidth + 1;

      this.RightGateTop = this.PitchIdent + this.OffsetTop - 1 + this.PitchImageHeight / 2 - this.PitchGateHeight/2;
      this.RightGateLeft = this.PitchIdent + this.OffsetLeft - this.PitchGateWidth + 1 + this.PitchImageWidth + this.PitchGateWidth;

      this.ReplayTop = this.OffsetTop + 10;
      this.ReplayLeft = this.OffsetLeft + 10;
    }

    componentWillReceiveProps(nextProps){
      if(this.props.currentEvent != nextProps.currentEvent) {
        this.cancelSceneIfPlaying();
        this._highLightPlayers(this.props.currentEvent, nextProps.currentEvent);
      }

      if(this.props.Scene != nextProps.Scene && nextProps.Scene != null){
        this.startScene(nextProps.Scene);
       }
    }

    componentDidUpdate(prevProps, prevState){
      if(this.props.width != prevProps.width) {
        this.calculateHtmlPositions();
        this.drawCanvasPitch();
        this.forceUpdate();
      }
    }

    startScene(scene){
        console.log(`start scene:`);
        console.log(scene);

        let Scene = null;

        switch(scene.type) {
          case sceneTypes.Goal:
            Scene = new Goal(scene.event, this);
            break;
          case sceneTypes.OwnGoal:
            Scene = new OwnGoal(scene.event, this);
            break;
          case sceneTypes.YellowCard:
            Scene = new YellowCard(scene.event, this);
            break;
          case sceneTypes.RedCard:
            Scene = new RedCard(scene.event, this);
            break;
          case sceneTypes.Offside:
            Scene = new Offside(scene.event, this);
            break;
          case sceneTypes.EndGame:
            Scene = new EndGame(scene.event, this);
            break;
          /*case sceneTypes.TacticsChange:
              return
            break;*/
          default:
             throw "Unknown scene type " + scene.type;
            break;
        }

        Scene.Play(this.props.GameSpeed)
          .then(()=> {
              console.log('end scene...');
              this.props.GameActions.END_SCENE();
            });

    }

    getPositionOnBench(entity) {
        let home = entity.props.home;

        if(entity.props.index != null) { //player
          let benchslot = entity.props.player.BenchSlot;
          return this.getBenchSlot(home, benchslot);
        }
        else {//manager
          return this.getBenchSlot(home, 0);
        }
    }

    getBenchSlot(home, index) {
        return {
          Top: home ? -5*this.server_metr : this.ServerPitchHeight + 5*this.server_metr,
          Left: this.ServerPitchWidth/2 - (2.5*this.server_metr + index*2*this.server_metr) + (home ? -0 : 0)
        }
    }

    getKeyPoints(home) {
      let bencheSlots = [];
      for (var index = 0; index < 8; index++) {
        bencheSlots.push(this.getBenchSlot(home, index));
      }

      return {
        center: {
          Top: this.ServerPitchHeight / 2,
          Left: this.ServerPitchWidth / 2
        },
        startPoint: {
          Top: home ? -3*this.server_metr : this.ServerPitchHeight + 3*this.server_metr,
          Left: this.ServerPitchWidth / 2
        },
        substitutionPoint: {
          Top: home ? 0 : this.ServerPitchHeight,
          Left: this.ServerPitchWidth / 2
        },
        benchSlots: bencheSlots,
        exit: {
          Top: home == true ? -150 : this.ServerPitchHeight+150,
          Left: this.ServerPitchWidth / 2
        },
        managerPoint: {
          Top: home ? -1*this.server_metr : this.ServerPitchHeight + 1*this.server_metr ,
          Left: this.ServerPitchWidth / 2 - 2.5*this.server_metr
        },
        celebrationPoint: {
          Top: !this.props.SidesChanged ? this.ServerPitchHeight / 2 - 100 : this.ServerPitchHeight / 2 + 100, 
          Left: !this.props.SidesChanged ? (this.ServerPitchWidth + 20) : -20
        }
      }
    }

    cancelSceneIfPlaying() {
        if(this.cancelSceneToken != null && this.cancelSceneToken.cancel != null) {
          this.cancelSceneToken.cancel();
          this.cancelSceneToken = null;
        }
    }

    _highLightPlayers(currentEvent, nextEvent) {
      if(window.Json.game[nextEvent-1].coordinates == null)
        return ;

      var playersDistanceToBallArray = [];
      playersDistanceToBallArray = playersDistanceToBallArray.concat(this.calculatePlayersDistanceToBall("home",currentEvent, nextEvent));
      playersDistanceToBallArray = playersDistanceToBallArray.concat(this.calculatePlayersDistanceToBall("away",currentEvent, nextEvent));

      playersDistanceToBallArray =  playersDistanceToBallArray.sort(function(a, b) {
        return a.distance - b.distance;
      });

      var maxPlayersToHighLight = 2;
      var playersToHighLight = [];
      for (var i = 0; i < playersDistanceToBallArray.length; i++) {
        if(playersToHighLight.length >= maxPlayersToHighLight)
          break;
        if(playersDistanceToBallArray[i].distance < 50){
          playersToHighLight.push(playersDistanceToBallArray[i].player);
        }
      }
      var gameSpeed = this.props.GameSpeed;
      var time = getInterval(currentEvent);
      setTimeout(() => this.highLightPlayers(playersToHighLight), gameSpeed*time*0.3);
    }

    highLightPlayers(players) {
      this.props.GameActions.highlighPlayers(players)
    }

    highLightPlayersByIds(ids){
      let playerStates = [];
      for (let index = 0; index < ids.length; index++) {
        let playerId = ids[index];
        playerStates.push(this.getPlayerState(playerId));
      }
      this.highLightPlayers(playerStates);
    }

    getPlayerState(id) {
      var result = null;
      this.props.HomeTeam.Players.forEach(function(player) {
        if(player.Id == id)
          result = player;
      }, this);
      this.props.AwayTeam.Players.forEach(function(player) {
        if(player.Id == id)
          result = player;
      }, this);

      return result;
    }

    calculatePlayersDistanceToBall(home_away, currentEvent, nextEvent) {
      var pos = window.Json.game[nextEvent-1].coordinates.ball;
      var ballPosition = this.convertToPitchPosition({Top: pos.h, Left: pos.w});

      var playersDistanceToBallArray = [];
      var coordinates = window.Json.game[nextEvent-1].coordinates;
      var playersCount = home_away == "home" ? coordinates.home.length : coordinates.away.length;
      for (var i = 0; i < 11 && i < playersCount; i++) {
        pos = home_away == "home" ? coordinates.home[i] : coordinates.away[i];
        var playerPosition = this.convertToPitchPosition({Top: pos.h, Left: pos.w}, home_away == "home");
        playersDistanceToBallArray.push({
          player: home_away == "home" ? this.props.HomeTeam.Players[i] : this.props.AwayTeam.Players[i],
          distance: this.calculateDistance(ballPosition, playerPosition)
        });
      }

      return playersDistanceToBallArray;
    }

    componentDidMount() {
      this.calculateHtmlPositions();
      this.drawCanvasPitch();
      this.forceUpdate();

      this.referee.getWrappedInstance().initBall(this.ball);
    }

    convertToPitchPosition(position, home=true){
      return {
        Top: (home ? position.Top : (this.ServerPitchHeight - position.Top)) * this.PitchImageHeight / this.ServerPitchHeight + this.PitchIdent + this.OffsetTop,
        Left: (home ? position.Left : (this.ServerPitchWidth - position.Left)) * this.PitchImageWidth / this.ServerPitchWidth + this.PitchIdent + this.OffsetLeft + (home === false && !this.props.windowMode ? -1 : 0)
      }
    }

    calculateDistance(position1, position2) {
      return Math.sqrt(Math.pow(position1.Top - position2.Top,2) + Math.pow(position1.Left - position2.Left,2));
    }

    reflectPosition(position) {
      return {
        Top: this.ServerPitchHeight - position.Top,
        Left: this.ServerPitchWidth - position.Left
      }
    }

    calculatePlayerSize() {     
      if(this.props.height < 400)
        return 0;

      if(this.props.height < 700)
        return 1;
      
      return 2;
    }

    readPlayers(home, playerSize){
      const { selectPlayer } = this.props.UserActions;
      var _this = this;

      var teamFromProps = home ? this.props.HomeTeam : this.props.AwayTeam;

      var oppositeShirtBackground = home ? this.props.AwayTeam.Back : this.props.HomeTeam.Back;
      var oppositeShirtTextColor = home ? this.props.AwayTeam.Color : this.props.HomeTeam.Color;

      return teamFromProps.Players.map(function(player, i) {
          return <Player key={player.Id}
                    player={player}
                    index={i}
                    num={player.Num}
                    home={home}
                    ref={(ref) => _this.players[home ? i : i+18]=ref}
                    onSelect={selectPlayer}
                    getPositionOnBench={_this.getPositionOnBench.bind(_this)}
                    convertToPitchPosition={_this.convertToPitchPosition.bind(_this)}
                    reflectPosition={_this.reflectPosition.bind(_this)}
                    getKeyPoints={_this.getKeyPoints.bind(_this)}
                    currentEvent={_this.props.currentEvent}
                    gameSpeed={_this.props.GameSpeed}
                    shirtBackground={i != 0 ? teamFromProps.Back : invertColor(oppositeShirtBackground)}
                    shirtTextColor={i != 0 ? teamFromProps.Color : invertColor(oppositeShirtTextColor)}
                    shirtBorderColor={i != 0 ? teamFromProps.Border : invertColor(oppositeShirtTextColor)}
                    pitchHeight={_this.ServerPitchHeight}
                    pitchIdent={_this.PitchIdent}
                    size={playerSize}
                  />;
      });
    }

    render() {
        var playerSize = this.calculatePlayerSize();
      
        var homePlayers = this.readPlayers(true, playerSize);
        var awayPlayers = this.readPlayers(false, playerSize);

        var players = homePlayers.concat(awayPlayers);

        const divStyle = {
          width: this.props.width + 'px',
          height: this.props.height + 'px'
        };

        return (<div className="pitch_container">
                  <div id={this.getPitchContainerId()} className={"pitch_canvas_container"+this.weather} style={divStyle}>
                    <canvas id={this.getCanvasPitchId()} width={this.props.width} height={this.props.height}>
                    </canvas>
                    <Gate side={"left"} windowMode={this.props.windowMode} width={this.PitchGateWidth} height={this.PitchGateHeight} left={this.LeftGateLeft} top={this.LeftGateTop} />
                    <Gate side={"right"} windowMode={this.props.windowMode} width={this.PitchGateWidth} height={this.PitchGateHeight} left={this.RightGateLeft} top={this.RightGateTop}  />
                    {players}
                    <Manager ref={(ref) => this.awayManager = ref} currentEvent={this.props.currentEvent} gameSpeed={this.props.GameSpeed} getKeyPoints={this.getKeyPoints.bind(this)} size={playerSize} shirtBackground={this.props.AwayTeam.Back} shirtTextColor={this.props.AwayTeam.Color} shirtBorderColor={this.props.AwayTeam.Border} onSelect={this.props.UserActions.selectManager} convertToPitchPosition={this.convertToPitchPosition.bind(this)} name={this.props.AwayTeam.manager.name} selected={this.props.AwayTeam.manager.selected} home={false} getPositionOnBench={this.getPositionOnBench.bind(this)} pitchHeight={this.ServerPitchHeight} pitchIdent={this.PitchIdent}/>
                    <Manager ref={(ref) => this.homeManager = ref} currentEvent={this.props.currentEvent} gameSpeed={this.props.GameSpeed} getKeyPoints={this.getKeyPoints.bind(this)} size={playerSize} shirtBackground={this.props.HomeTeam.Back} shirtTextColor={this.props.HomeTeam.Color} shirtBorderColor={this.props.HomeTeam.Border} onSelect={this.props.UserActions.selectManager} convertToPitchPosition={this.convertToPitchPosition.bind(this)} name={this.props.HomeTeam.manager.name} selected={this.props.HomeTeam.manager.selected} home={true} getPositionOnBench={this.getPositionOnBench.bind(this)} pitchHeight={this.ServerPitchHeight} pitchIdent={this.PitchIdent}/>
                    <Ball ref={(ref) => this.ball = ref} convertToPitchPosition={this.convertToPitchPosition.bind(this)} getKeyPoints={this.getKeyPoints.bind(this)} reflectPosition={this.reflectPosition.bind(this)} weather={parseInt(this.weather)} pitchHeight={this.ServerPitchHeight} pitchIdent={this.PitchIdent}
                      currentEvent={this.props.currentEvent}
                      gameSpeed={this.props.GameSpeed}
                    />
                    <Referee ref={(ref) => this.referee = ref} size={playerSize} convertToPitchPosition={this.convertToPitchPosition.bind(this)} getKeyPoints={this.getKeyPoints.bind(this)}  gameSpeed={this.props.GameSpeed} currentEvent={this.props.currentEvent} pitchHeight={this.ServerPitchHeight} pitchIdent={this.PitchIdent}/>
                    <Linesman ref={(ref) => this.homeLinesman = ref} size={playerSize} home={true} sidesChanged={this.props.SidesChanged} pitchWidth={this.ServerPitchWidth} getKeyPoints={this.getKeyPoints.bind(this)} convertToPitchPosition={this.convertToPitchPosition.bind(this)} gameSpeed={this.props.GameSpeed} currentEvent={this.props.currentEvent} pitchHeight={this.ServerPitchHeight} pitchIdent={this.PitchIdent}/>
                    <Linesman ref={(ref) => this.awayLinesman = ref} size={playerSize} home={false} sidesChanged={this.props.SidesChanged} pitchWidth={this.ServerPitchWidth} getKeyPoints={this.getKeyPoints.bind(this)} convertToPitchPosition={this.convertToPitchPosition.bind(this)} gameSpeed={this.props.GameSpeed} currentEvent={this.props.currentEvent} pitchHeight={this.ServerPitchHeight} pitchIdent={this.PitchIdent}/>
                    {this.props.Replay == true ? <div className="replay" style={{top: this.ReplayTop + 'px', left: this.ReplayLeft + 'px'}}>Повтор</div> : null}
                  </div>
                </div>
        )
    }

    getCanvasPitchId() {
      return this.props.windowMode ? "new_pitch_window" : "new_pitch";
    }

    getPitchContainerId() {
      return this.props.windowMode ? "pitch_container_window" : "pitch_container";
    }

    drawCanvasPitch() {
        var canvas = document.getElementById(this.getCanvasPitchId());
        var ctx = canvas.getContext("2d");

        var opacity = 0.5 + this.weather * 0.25;

        ctx.strokeStyle="rgba(255,255,255," + opacity + ")";
        ctx.fillStyle="rgba(255,255,255,0.5)";
        ctx.lineWidth="2";

        /*var img = new Image();
        img.src = './images/grass'+this.weather+'.png';

        var pattern = ctx.createPattern(img, 'repeat');*/
        //ctx.fillStyle = pattern;
        this.drawPitchLines(canvas, ctx);
    }

    drawPitchLines(canvas, ctx){
      ctx.fillStyle="rgba(255,255,255,0.5)";

      // Outer lines
      ctx.beginPath();
      ctx.rect(this.PitchIdent,this.PitchIdent, this.PitchImageWidth, this.PitchImageHeight);
      ctx.stroke();
      ctx.closePath();

      // Mid line
      ctx.beginPath();
      ctx.moveTo( this.PitchImageWidth / 2 + this.PitchIdent, this.PitchIdent);
      ctx.lineTo(this.PitchImageWidth / 2 + this.PitchIdent, this.PitchImageHeight+this.PitchIdent);
      ctx.stroke();
      ctx.closePath();

      //Mid circle
      ctx.beginPath()
      ctx.arc(this.PitchImageWidth / 2 + this.PitchIdent, this.PitchImageHeight / 2 +this.PitchIdent, this.PitchPenaltyBoxWidth*9.15/16.5, 0, 2*Math.PI, false);
      ctx.stroke();
      ctx.closePath();
      //Mid point
      ctx.beginPath()
      ctx.arc(this.PitchImageWidth / 2 + this.PitchIdent, this.PitchImageHeight / 2 +this.PitchIdent, 2, 0, 2*Math.PI, false);
      ctx.fill();
      ctx.closePath();

      //Home penalty box
      ctx.beginPath();
      ctx.rect(this.PitchIdent, (this.PitchImageHeight - this.PitchPenaltyBoxHeight) / 2 +  this.PitchIdent, this.PitchPenaltyBoxWidth, this.PitchPenaltyBoxHeight);
      ctx.stroke();
      ctx.closePath();

      //Home goal box
      ctx.beginPath();
      ctx.rect(this.PitchIdent, this.PitchIdent + this.PitchImageHeight / 2 - 9*this.PitchPenaltyBoxWidth/16.5, 5.5*this.PitchPenaltyBoxWidth/16.5, 18*this.PitchPenaltyBoxWidth/16.5);
      ctx.stroke();
      ctx.closePath();

      //Home half circle
      ctx.beginPath()
      ctx.arc(this.PitchPenaltyBoxWidth*2/3 + this.PitchIdent, this.PitchImageHeight / 2 + this.PitchIdent, 55*this.PitchImageWidth / this.ServerPitchWidth, 0.29*Math.PI, 1.71*Math.PI, true);
      ctx.stroke();
      ctx.closePath();

      //home pentalty point
      ctx.beginPath()
      ctx.arc(this.PitchPenaltyBoxWidth*2/3 + this.PitchIdent, this.PitchImageHeight / 2 + this.PitchIdent, 2, 0, 2*Math.PI, false);
      ctx.fill();
      ctx.closePath();

      //Home L corner
      ctx.beginPath()
      ctx.arc(this.PitchIdent, this.PitchIdent, 8, 0, 0.5*Math.PI, false);
      ctx.stroke();
      ctx.closePath();
      //Home R corner
      ctx.beginPath()
      ctx.arc(this.PitchIdent, this.PitchImageHeight + this.PitchIdent, 8, 0, 1.5*Math.PI, true);
      ctx.stroke();
      ctx.closePath();


      //Away penalty box
      ctx.beginPath();
      ctx.rect(this.PitchIdent + this.PitchImageWidth - this.PitchPenaltyBoxWidth, (this.PitchImageHeight - this.PitchPenaltyBoxHeight) / 2 +  this.PitchIdent, this.PitchPenaltyBoxWidth, this.PitchPenaltyBoxHeight);
      ctx.stroke();
      ctx.closePath();

      //Away goal box
      ctx.beginPath();
      ctx.rect(this.PitchIdent + this.PitchImageWidth - 5.5*this.PitchPenaltyBoxWidth/16.5, this.PitchIdent + this.PitchImageHeight / 2 - 9*this.PitchPenaltyBoxWidth/16.5, 5.5*this.PitchPenaltyBoxWidth/16.5, 18*this.PitchPenaltyBoxWidth/16.5);
      ctx.stroke();
      ctx.closePath();

      //Away pentalty point
      ctx.beginPath()
      ctx.arc(this.PitchIdent + this.PitchImageWidth - this.PitchPenaltyBoxWidth*2/3, this.PitchImageHeight / 2 + this.PitchIdent, 2, 0, 2*Math.PI, false);
      ctx.fill();
      ctx.closePath();

      //Away half circle
      ctx.beginPath()
      ctx.arc(this.PitchIdent + this.PitchImageWidth - this.PitchPenaltyBoxWidth*2/3, this.PitchImageHeight / 2 + this.PitchIdent, 55*this.PitchImageWidth / this.ServerPitchWidth, 0.71*Math.PI, 1.29*Math.PI, false);
      ctx.stroke();
      ctx.closePath();

      //Away L corner
      ctx.beginPath()
      ctx.arc(this.PitchIdent+ this.PitchImageWidth, this.PitchIdent, 8, 0.5*Math.PI, 1*Math.PI, false);
      ctx.stroke();
      ctx.closePath();
      //Away R corner
      ctx.beginPath()
      ctx.arc(this.PitchIdent+ this.PitchImageWidth, this.PitchImageHeight + this.PitchIdent, 8, 1*Math.PI, 1.5*Math.PI, false);
      ctx.stroke();
      ctx.closePath();

      // home technical zone / 2
      ctx.beginPath();
      ctx.rect(this.PitchIdent + this.PitchImageWidth / 2 - this.technicalZoneWidth - this.distanceBeetwenZones / 2 , this.PitchIdent - this.technicalZoneHeight - this.metr, this.technicalZoneWidth, this.technicalZoneHeight);
      ctx.stroke();
      ctx.closePath();

      // away technical zone
      ctx.beginPath();
      ctx.rect(this.PitchIdent + this.PitchImageWidth / 2 + this.distanceBeetwenZones / 2 , this.PitchIdent - this.technicalZoneHeight - this.metr, this.technicalZoneWidth, this.technicalZoneHeight);
      ctx.stroke();
      ctx.closePath();
    }
}

function invertColor(hex) {
    if (hex.indexOf('#') === 0) {
        hex = hex.slice(1);
    }
    // convert 3-digit hex to 6-digits.
    if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length !== 6) {
        throw new Error('Invalid HEX color: ' + hex);
    }
    // invert color components
    var r = (255 - parseInt(hex.slice(0, 2), 16)).toString(16),
        g = (255 - parseInt(hex.slice(2, 4), 16)).toString(16),
        b = (255 - parseInt(hex.slice(4, 6), 16)).toString(16);
    // pad each with zeros and return
    return "#" + padZero(r) + padZero(g) + padZero(b);
}

function padZero(str, len) {
    len = len || 2;
    var zeros = new Array(len).join('0');
    return (zeros + str).slice(-len);
}

function mapStateToProps(state, ownProps) {
    return {
        HomeTeam: state.HomeTeam,
        AwayTeam: state.AwayTeam,
        Score: state.Score,
        Ball: state.Ball,
        currentEvent: state.currentEvent,
        GameSpeed: state.gameSpeed,
        weather: state.weather,
        Scene: state.scene,
        Replay: state.replay != null,
        SidesChanged: state.sidesSwap % 2 != 0
    };
}

function mapDispatchToProps(dispatch) {
    return {
        UserActions: bindActionCreators(UserActions, dispatch),
        GameActions: bindActionCreators(GameActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Pitch)



/** WEBPACK FOOTER **
 ** ./src/components/Pitch/Pitch.js
 **/